import React from 'react';
import { Route } from 'react-router';

import VendorRoutes from './vendors/routes';
import LocationRoutes from './locations/routes';
import AddPurchaseOrder from './order/AddPoForm';

const Routes = () => (
  <Route path="purchase-orders">
    {VendorRoutes()}
    {LocationRoutes()}
    <Route path="create" component={AddPurchaseOrder} />
  </Route>
);

export default Routes;
